<template>

    <v-progress-linear  
        :color="color"
        indeterminate
    ></v-progress-linear>  
  
</template>

<script>

const colorArray = [
  "yellow darken-2",
  "green",
  "teal",
  "cyan",
  "purple",
  "red",
  "amber",
  "green",
  "indigo"
  ];

const typeArray = [
  "line"
]

export default {


    data: function(){
      return({
          color: colorArray[Math.floor(Math.random() * colorArray.length)],
          type: typeArray[0],
        })
    },
}

</script>

<style>

</style>